import { provideContext } from "@starter/core";

// La feuille Tailwind est chargée DEUX fois, volontairement :
//   1. ici, au niveau du DOCUMENT → reset et styles de <body> ;
//   2. dans chaque composant via TailwindElement → les classes franchissent le Shadow DOM.
// Sans (1) la page n'a ni reset ni fond ; sans (2) les classes des composants ne font rien.
import "@starter/core/styles.css";

import { api, tokenStore } from "./config";

// Doit précéder tout rendu : les features résolvent le contexte à leur premier appel.
// C'est ce qui leur évite d'importer `@starter/app` — dépendance qui casserait le prune.
provideContext({ api, tokenStore, baseUrl: import.meta.env.VITE_API_BASE_URL });

import("./app-shell").catch((cause: unknown) => {
  console.error("Impossible de charger le shell applicatif", cause);
});
